module.exports = __webpack_public_path__ + "img/noel.73d4214d.jpg";